import React, { useState } from 'react';
import { Modal, Typography } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { ProductDetail } from '../../../../../context/viator-product-types';
import { STRINGS, FORMATTED_STRINGS, formatDaysString } from './strings';

interface CancellationPolicyProps {
    cancellationPolicy: ProductDetail['cancellationPolicy']
}

const { Link } = Typography;

const CancellationPolicy: React.FC<CancellationPolicyProps> = ({
    cancellationPolicy
}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const cancellationType = cancellationPolicy.type;
    const refundEligibility = cancellationPolicy.refundEligibility;

    const getMessage = () => {
        switch (cancellationType) {
            case 'STANDARD':
                if (!refundEligibility?.length) {
                    return STRINGS.FREE_CANCELLATION_AVAILABLE;
                }
                const fullRefundPolicy = refundEligibility.find(policy => policy.percentageRefundable === 100);
                if (fullRefundPolicy) {
                    return formatDaysString(FORMATTED_STRINGS.FREE_CANCELLATION_DAYS_BEFORE, fullRefundPolicy.dayRangeMin);
                }
                return cancellationPolicy.description || STRINGS.FREE_CANCELLATION_AVAILABLE;
            case 'ALL_SALES_FINAL':
                return STRINGS.NON_REFUNDABLE;
            case 'CUSTOM':
                const customFullRefundPolicy = refundEligibility?.find(policy => policy.percentageRefundable === 100);
                console.log(customFullRefundPolicy);
                if (customFullRefundPolicy) {
                    return formatDaysString(FORMATTED_STRINGS.FREE_CANCELLATION_DAYS_BEFORE_SELECTED_DATE, customFullRefundPolicy.dayRangeMin);
                }
                return cancellationPolicy.description || STRINGS.CUSTOM_CANCELLATION_POLICY;
            default:
                return STRINGS.CANCELLATION_UNAVAILABLE;
        }
    };

    const getDetailedMessage = () => {
        if (cancellationType === 'CUSTOM') {
            let message = cancellationPolicy.description;
            if (cancellationPolicy.cancelIfBadWeather) {
                message += "\n\n" + STRINGS.BAD_WEATHER_POLICY;
            }
            
            if (cancellationPolicy.cancelIfInsufficientTravelers) {
                message += "\n\n" + STRINGS.MINIMUM_TRAVELERS_POLICY;
            }
            return message || STRINGS.CUSTOM_CANCELLATION_UNAVAILABLE;
        }

        let message = getMessage();
        
        if (cancellationType === 'STANDARD') {
            const fullRefundPolicy = refundEligibility?.find(policy => policy.percentageRefundable === 100);
            if (fullRefundPolicy) {
                message += "\n\n" + STRINGS.CANCELLATION_POLICY_DETAILS;
                message += "\n• " + formatDaysString(FORMATTED_STRINGS.CANCEL_UP_TO_DAYS, fullRefundPolicy.dayRangeMin);
                message += "\n• " + formatDaysString(FORMATTED_STRINGS.NO_REFUND_LESS_THAN_DAYS, fullRefundPolicy.dayRangeMin);
                message += "\n• " + formatDaysString(FORMATTED_STRINGS.NO_CHANGES_LESS_THAN_DAYS, fullRefundPolicy.dayRangeMin);
                message += "\n• " + STRINGS.CUTOFF_TIMES_LOCAL;
            }
            
            if (cancellationPolicy.cancelIfBadWeather) {
                message += "\n• " + STRINGS.BAD_WEATHER_POLICY;
            }
            
            if (cancellationPolicy.cancelIfInsufficientTravelers) {
                message += "\n• " + STRINGS.MINIMUM_TRAVELERS_POLICY;
            }
        }
        
        return message;
    };

    return (
        <>
            <Link
                onClick={() => (cancellationType === 'STANDARD' || cancellationType === 'CUSTOM') ? setIsModalVisible(true) : undefined}
                style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    marginBottom: '16px',
                    color: cancellationType === 'ALL_SALES_FINAL' ? '#faad14' : '#1890ff'
                }}
            >
                <InfoCircleOutlined style={{ marginRight: '8px', color: cancellationType === 'ALL_SALES_FINAL' ? '#faad14' : '#1890ff' }} />
                {/* <span dangerouslySetInnerHTML={{ __html: getMessage() }} /> */}
                <span>{cancellationType === 'ALL_SALES_FINAL' ? getMessage() : 'Ver políticas de cancelación'}</span>
            </Link>
            <Modal
                title={STRINGS.CANCELLATION_POLICY_TITLE}
                open={isModalVisible}
                onOk={() => setIsModalVisible(false)}
                onCancel={() => setIsModalVisible(false)}
            >
                <p style={{ whiteSpace: 'pre-line' }}>{<span dangerouslySetInnerHTML={{ __html: getDetailedMessage() }} />}</p>
            </Modal>
        </>
    );
};

export default CancellationPolicy;